export default {
	/**
	 * Set all categories
	 * @param {Object} categories 
	 */
	setAll(state, languages) {
		state.all = languages
	},
}
